import React, { cloneElement } from "react";
import type { WidgetProps } from "@rjsf/utils";
import { spacing } from "../../../../../../../../stitches.config";
import {
  FieldPathProvider,
  useFieldPath,
} from "../../../FieldPathContext/FieldPathContext";
import {
  isFieldSelected,
  useSubmissionsBuilderContext,
} from "../../../SubmissionsBuilderContext";
import { withStopPropagation } from "../../../utils";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";

type BaseWidgetPreviewProps = WidgetProps & { children: React.JSX.Element };

function WrappedBaseWidgetPreview({ children }: BaseWidgetPreviewProps) {
  const { selectField, selectedField } = useSubmissionsBuilderContext();
  const { pathArray } = useFieldPath();

  const isSelected = isFieldSelected(pathArray, selectedField);

  return (
    <BuilderFieldWrapper
      onClick={withStopPropagation(() => {
        selectField(pathArray);
      })}
      isSelected={isSelected}
    >
      <div style={{ marginBottom: spacing.xs.toString() }}>
        {cloneElement(children, { isSubmissionBuilder: true })}
      </div>
    </BuilderFieldWrapper>
  );
}

export function BaseWidgetPreview(props: BaseWidgetPreviewProps) {
  return (
    <FieldPathProvider path={props.name}>
      <WrappedBaseWidgetPreview {...props} />
    </FieldPathProvider>
  );
}
